import { coreFeatures } from '@/mocks/comics';

const tickers = ['同看', '一起追', '实时同步', '边看边聊', '追更不孤单', '漫友共读', '热门漫画', '同步更新'];

export default function Features() {
  const items = [...tickers, ...tickers];

  return (
    <section id="features" className="relative py-16 md:py-24">
      <div className="overflow-hidden border-y border-background-200/60 bg-background-100/40 py-4">
        <div className="marquee-track flex w-max animate-marquee gap-10">
          {items.map((t, i) => (
            <span
              key={`${t}-${i}`}
              className="flex items-center gap-10 whitespace-nowrap text-sm tracking-widest text-foreground-500"
            >
              <span className="font-heading text-lg text-foreground-300">{t}</span>
              <i className="ri-sparkling-line text-primary-400"></i>
            </span>
          ))}
        </div>
      </div>

      <div className="container-site mt-16 md:mt-20">
        <div className="reveal mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium uppercase tracking-[0.3em] text-primary-400">
            核心玩法
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            一个人追更太孤单？那就一起看
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            同看、一起追、实时同步更新，三大能力让你和漫友始终同频，把追漫画变成一场热热闹闹的社交。
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {coreFeatures.map((f, idx) => (
            <article
              key={f.title}
              className={`reveal group relative overflow-hidden rounded-2xl border border-background-200/70 bg-background-100/60 p-7 transition-all hover:-translate-y-1.5 hover:border-primary-400/50`}
              style={{ transitionDelay: `${idx * 90}ms` }}
            >
              <span className="absolute -right-2 -top-4 font-heading text-7xl text-background-300/40">
                {String(idx + 1).padStart(2, '0')}
              </span>
              <div className="relative flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-500/15 text-primary-400 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${f.icon} text-2xl`}></i>
              </div>
              <h3 className="relative mt-6 font-heading text-2xl text-foreground-950">{f.title}</h3>
              <p className="relative mt-3 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}